<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #DETAILS="{ visible, params }">
      <Details v-if="visible" :row="params"></Details>
    </template>
    <template #Email="{ visible, params }">
      <EmailDetails v-if="visible" :row="params"></EmailDetails>
    </template>
  </cTable>
</template>

<script>
import {
  getBill,
  add,
  getDetails,
  del,
  getBillClient,
  resetAmount,
  postAudit,
  postConfirm,
  getConfig,
  updateBill,
  ConversionUsd,
  getUsdRate,
  getMonthUsers,
  createMonthUserBill,
  exportMonthBill,
  exportAllBill,
  getOperator,
  previewEmail
} from "@/api/finance/bill";
import { getAllClient, getCompanies } from "@/api/user/client";

import numFun from "@/utils/numFun";

import cTable from "@/base/common/index";
import Details from "./details";
import EmailDetails from "./email_details";

export default {
  name: "branch_bill",
  components: {
    cTable,
    Details,
    EmailDetails
  },
  data() {
    let options = [
      { label: this.$t("month_t"), value: "MONTH" },
      { label: this.$t("half_moon"), value: "HALFMONTH" },
      { label: this.$t("week"), value: "WEEK" },
      { label: this.$t("day"), value: "DAY" }
    ];
    return {
      methods: {
        list: getBill,
        getCompanies,
        add,
        getDetails,
        del,
        getBillClient,
        resetAmount,
        postAudit,
        postConfirm,
        getConfig,
        updateBill,
        getAllClient,
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          this.totalAmount.push([
            {
              text: this.$t("total"),
              replace_currency: "",
              total_amount: data.totalAmount
            }
          ]);
        },
        ConversionUsd,
        createMonthUserBill,
        getUsdRate,
        getMonthUsers,
        exportMonthBill,
        exportAllBill,
        getOperator
      },
      totalAmount: [],
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = {
                show_sku: row.show_sku
              };
              let requestType = "";
              if (row.period == "MONTH") {
                data.client_id = this.selectAll.map(item => item.client_id);
                requestType = "createMonthUserBill";
                if (data.client_id.length > 1) {
                  this.$Message["error"]({
                    background: true,
                    content: this.$t("rule_sel_tips"),
                    duration: 5
                  });
                  return;
                }
              } else {
                data.cache_token = this.selectAll.map(
                  item => item.airway_token
                );
                requestType = "add";
              }
              this.$page.handleRequestMethods(requestType, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              period: [
                {
                  required: true,
                  message: "Please select period",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ period: 24 }, { show_sku: 24 }, { client: 24 }],
          fields: [
            {
              name: () => this.$t("period"),
              key: "period",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("period"),
              options: options,
              methods: {
                async "on-change"({ formData }) {
                  try {
                    this.$page.getModal("add").list = [];
                    if (formData.period) {
                      let data =
                        formData.period != "MONTH"
                          ? (
                              await this.$page.handleRequestMethods(
                                "getBillClient",
                                this.formData
                              )
                            ).payload
                          : (
                              await this.$page.handleRequestMethods(
                                "getMonthUsers"
                              )
                            ).payload;
                      this.$page.getModal("add").client = this.$page.getModal(
                        "add"
                      ).list = data;
                    }
                  } catch (error) {}
                }
              }
            },
            {
              name: () => this.$t("whether") + this.$t("show1") + "SKU",
              key: "show_sku",
              component: "Radio",
              placeholder: () =>
                this.$t("select") +
                this.$t("whether") +
                this.$t("show1") +
                "SKU",
              options: [
                {
                  label: this.$t("YES"),
                  value: 1
                },
                {
                  label: this.$t("NO"),
                  value: 0
                }
              ],
              bind: {
                border: true
              },
              default: 0
            },
            {
              name: () => this.$t("clientName"),
              key: "client",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("clientName") + this.$t("search"),
              methods: {
                "on-search"({ formData }) {
                  let that = this.$page.getModal("add");
                  let arr = that.client;
                  if (formData.client == "") {
                    that.list = arr;
                    return;
                  }
                  that.list = arr.filter(
                    item =>
                      item.shipper_account
                        .toLowerCase()
                        .indexOf(formData.client.toLowerCase()) !== -1
                  );
                }
              },
              bind: {
                suffix: "ios-search",
                search: true
              }
            }
          ],
          table: {
            config: {
              height: 300
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
                fixed: "left"
              },
              {
                name: () => this.$t("clientName"),
                align: "left",
                key: "shipper_account",
                minWidth: 100
              },
              {
                name: () => this.$t("period"),
                key: "billing_cycle",
                align: "center",
                minWidth: 100,
                methods: {
                  render() {
                    return options.find(
                      item =>
                        item.value ==
                        this.getModal("add").$refs["form"].formData.period
                    ).label;
                  }
                }
              },
              {
                name: () => this.$t("salesman"),
                key: "salesman_account",
                align: "left",
                minWidth: 100
              }
            ]
          }
        },
        update: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("updateBill", row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ],
              total_real_amount: [
                {
                  required: true,
                  message: "Please Enter total_real_amount",
                  trigger: "blur"
                }
              ],
              total_fee: [
                {
                  required: true,
                  message: "Please Enter total_fee",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ name: 24 }, { rate: 24 }],
          fields: [
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },

            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            }
          ]
        },
        writeOff: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("postAudit", row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 400,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              status: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ status: 24 }],
          fields: [
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                { label: this.$t("refuse"), value: 0 },
                { label: this.$t("allow"), value: 1 }
              ],
              bind: {
                border: true
              }
            }
          ]
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500
            },
            modalContentBind: {
              style: {
                height: "700px"
              }
            }
          },
          footer: { show: () => false }
        },
        calculate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("ConversionUsd", row, true)
                .then(() => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ],
              rate: [
                {
                  required: true,
                  type: "number",
                  message: "Please Enter rate",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ name: 24 }, { rate: 24 }],
          fields: [
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },

            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            }
          ]
        },
        preview: {
          contentSlot: "Email",
          config: {
            modalBind: {
              // draggable: true,
              // transfer: true,
              width: 920
            }
          },
          footer: { show: () => false }
        }
      },
      footer: {
        show: () => true,
        render: h => {
          return h(
            "div",
            {
              class: "footer-content"
            },
            this.totalAmount.map(item => {
              return h(
                "div",
                {
                  class: "footer-content-item"
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title"
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  )
                ]
              );
            })
          );
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          // {
          //   key: "time_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   component: "Select",
          //   options: []
          // },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            component: "Select",
            options: []
          },
          {
            key: "clientId",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            }
          },
          {
            key: "operator_id",
            placeholder() {
              return this.$t("select") + this.$t("status_operator");
            },
            component: "Select",
            options: []
            // config: {
            //   label: "account",
            //   value: "id"
            // }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-add",
                type: "warning"
              }
              // id: 127
            },
            {
              name: this.$t("export"),
              // type: "export",
              // fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary"
              },
              list: [
                {
                  name: () => this.$t("ListData"),
                  type: "export",
                  fnName: "export",
                  disabled() {
                    return !this.selectAll.length;
                  }
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                },
                {
                  name: this.$t("month_t") + this.$t("bill1"),
                  type: "monthBill",
                  fnName: "monthBill",
                  disabled() {
                    return !this.selectAll.length;
                  }
                  // id: 305
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                },
                {
                  name: this.$t("summary") + this.$t("export"),
                  type: "allBill",
                  fnName: "allBill",
                  disabled() {
                    return !this.selectAll.length;
                  }
                  // id: 529
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                }
              ]
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            allBill() {
              let data = {
                bill_id: this.selectAll.map(item => item.id)
              };
              this.openLoading();
              this.handleRequestMethods("exportAllBill", data).then(res => {
                window.open(this.$globalUrl + res.payload);
                this.closeLoading();
              });
            },
            monthBill() {
              let data = {
                id: this.selectAll.map(item => item.id)
              };
              this.openLoading();
              this.handleRequestMethods("exportMonthBill", data).then(res => {
                window.open(this.$globalUrl + res.payload);
                this.closeLoading();
              });
            },
            add() {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").type = "add";
              this.getModal("add").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          align: "center",
          component: "Button",
          minWidth: 180,
          copy: true,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            render({ row }) {
              return row.bill_number;
            },
            click({ row }) {
              this.$page.getModal("showDetails").open(row, function() {
                this.setTitle(row.bill_number);
              });
            }
          }
        },
        {
          name: () => this.$t("codNAme"),
          align: "center",
          key: "name",
          minWidth: 100
        },
        {
          name: () => this.$t("orderNums"),
          key: "order_nums",
          align: "center",
          minWidth: 80
        },
        // {
        //   name: () => this.$t("total_votes"),
        //   align: "center",
        //   key: "total_votes",
        //   width: 80
        // },
        {
          name: () => this.$t("amount") + "(CNY)",
          key: "total_cny",
          align: "center",
          width: 120
        },
        {
          name: () => this.$t("amount") + "(USD)",
          align: "center",
          key: "total_usd",
          width: 120
        },
        // {
        //   name: () => this.$t("rate") + "(USD-CNY)",
        //   align: "center",
        //   key: "usd_to_cny_rate",
        //   width: 130
        // },
        {
          name: () => this.$t("total_amount") + "(CNY)",
          align: "center",
          key: "amount",
          width: 110
        },
        {
          name: () => this.$t("total_amount") + "(USD)",
          align: "center",
          key: "amount_usd",
          width: 110
        },
        {
          name: () => "CNY to USD",
          align: "center",
          key: "cny_to_usd_rate",
          width: 110
        },

        {
          name: () => this.$t("clientName"),
          align: "center",
          key: "clientInfo",
          width: 100,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$t("ownership"),
          align: "center",
          key: "byCompany",
          width: 100,
          methods: {
            render({ value }) {
              return value && value.title;
            }
          }
        },
        {
          name: () => this.$t("status_operator"),
          align: "center",
          key: "operatorInfo",
          width: 100,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$t("audit"),
          align: "center",
          key: "auditInfo",
          width: 100,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$t("createTime"),
          align: "center",
          key: "create_time",
          width: 170
        },
        {
          name: () => this.$t("confirm_time"),
          key: "confirm_time",
          align: "center",
          minWidth: 170
        },
        {
          name: () => this.$t("audit_time"),
          key: "audit_time",
          align: "center",
          minWidth: 170
        },
        {
          name: () => this.$t("paid_time"),
          key: "paid_time",
          align: "center",
          minWidth: 170
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("b2bClient") + this.$t("order_desc"),
          key: "client_remarks",
          align: "center",
          minWidth: 100
        },
        // {
        //   name: () => this.$t("b2bClient") + this.$t("order_desc"),
        //   key: "client_remarks",
        //   align: "center",
        //   minWidth: 170
        // },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 500,
          fixed: "right",
          list: [
            {
              name: () => this.$t("to_usd") + this.$t("Conversion"),
              type: "Conversion",
              fnName: "ConversionFun",
              bind: {
                type: "warning"
              },
              disabled({ row }) {
                return row.amount_usd !== "0.00";
              }
              // id: 460
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              disabled({ row }) {
                return row.status == "WAIT_CONFIRM" || row.status == "DISAGREE"
                  ? false
                  : true;
              }
              // id: 353
            },
            {
              name: () => this.$t("confirmOrder"),
              type: "confirmOrder",
              fnName: "confirmOrder",
              bind: {
                type: "error"
              },
              disabled({ row }) {
                return row.status != "WAIT_CONFIRM";
              }
              // id: 129
            },
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              bind: {
                type: "warning"
              },
              disabled({ row }) {
                return row.status != "CONFIRMED";
              }
              // id: 130
            },
            {
              name: () => this.$t("email") + this.$t("preview"),
              type: "preview",
              fnName: "preview",
              bind: {
                type: "success"
              },
              disabled({ row }) {
                return row.status != "CONFIRMED";
              }
            },
            {
              name: () => this.$t("resAmount"),
              align: "center",
              width: 100,
              fnName: "recalculate",
              bind: {
                type: "error",
                size: "small"
              },
              disabled({ row }) {
                return row.status != "WAIT_CONFIRM";
              },
              // if: 134,
              methods: {
                render() {
                  return this.$t("resAmount");
                }
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled({ row }) {
                return row.status != "WAIT_CONFIRM";
              }
              // id: 131
            }
          ],
          methods: {
            recalculate({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("resAmount"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("resetAmount", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            ConversionFun({ row }) {
              this.handleRequestMethods("getUsdRate").then(res => {
                this.getModal("calculate").open(
                  {
                    name: row.name,
                    rate: res.payload,
                    id: row.id
                  },
                  function() {
                    this.setTitle(
                      row.bill_number +
                        "(" +
                        this.$t("to_usd") +
                        this.$t("Conversion") +
                        ")"
                    );
                  }
                );
              });
            },
            // add({ row }) {
            //   this.getModal("add").open({ id: row.id }, function () {
            //     this.setTitle(row.bill_number + "(" + this.$t("addTo") + ")");
            //   });
            // },
            update({ row }) {
              this.getModal("update").open(
                {
                  name: row.name,
                  rate: row.usd_to_cny_rate,
                  id: row.id
                },
                function() {
                  this.setTitle(
                    row.bill_number + "(" + this.$t("update") + ")"
                  );
                }
              );
            },
            preview({ row }) {
              previewEmail({ bill_id: row.id }).then(res => {
                if (res.data.status) {
                  this.getModal("preview").open(res.data.payload, function() {
                    this.setTitle(
                      row.bill_number +
                        "(" +
                        this.$t("email") +
                        this.$t("preview") +
                        ")"
                    );
                  });
                }
              });
              // console.log(row);
            },
            confirmOrder({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("confirmOrder"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("postConfirm", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            writeOff({ row }) {
              this.getModal("writeOff").open({ id: row.id }, function() {
                this.setTitle(
                  row.bill_number + "(" + this.$t("writeOff") + ")"
                );
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  async mounted() {
    let data = (await getConfig()).data.payload;
    let client = (await getAllClient()).data.payload.rows;
    let operator = (await getOperator()).data.payload;
    let companiesList = (await getCompanies()).data.payload;
    this.header.searchs.forEach(item => {
      if (item.key === "status")
        item.options = Object.keys(data.status).map(item => ({
          value: item,
          label: data.status[item]
        }));
      if (item.key === "clientId") item.options = client;
      if (item.key === "operator_id") item.options = operator;
      if (item.key === "ownership") item.options = companiesList;
    });
  }
};
</script>
